import { Row, Col } from "./Flexbox";
import Text from "./Text";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const FilesContainer = props => {
    return (
        <Col className ="filesMainContainer"
            style={{
                flex:'none', width: '100%', 
                marginTop: props.opacity ? 16 : 0, marginBottom: props.opacity ? 16 : 24, 
                opacity: props.opacity, 
                transition: 'opacity 0.7s ease-in-out'}}>
            <Row 
                style={{
                    justifyContent:'space-between',
                    width:'100%', 
                    flexWrap:'wrap', rowGap:16}}>
                {props.files.map(((file, index) =>(
                    <Row key={`${file.name}-${file.size}-${file.type}`} style={{border:'solid 1px', borderColor: props.theme.Ey, borderRadius:4, padding:16, alignItems:'center', width: 316, flex:'none'}}>
                        <Col style={{alignItems:'flex-start'}}>
                            <Text color={props.theme.THREEB} size={17} weight={"medium"} style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: 255}}>{file.name}</Text>
                            <Text color={props.theme.Audi} size={15} weight={"medium"}>{Math.ceil(file.size/1024)} KB</Text>
                        </Col>
                        <Col style={{flex:'none', height:'100%'}}>
                            <RemoveCircleIcon onClick={() => props.removeFile(index)} style={{color:props.theme.Red, fontSize: 24, cursor:'pointer'}}/>
                        </Col>
                    </Row>
                    )
                ))}
                
                
            </Row>
        </Col>
    )
}

export default FilesContainer;